import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';
import moment from 'moment';

export function addSubJobChecklist({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  setTimeout(() => {
    //设置默认选择的Group
    let formData = parameter;
    //设置富文本的控件为空字符串，否则会崩
    formData['Comments'] = '';
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData });

    setTimeout(() => {
      //ChecklistStatusSetId设置备选项里第一个
      if (sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'] !== undefined) {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusSetId', sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'][0].Value);
        getChecklistStatusSelectOptionList({ sectionName: sectionName, parameter: sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'][0].Value, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
      }

      //ChecklistStatusId设置备选项里第一个
      if (sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusId'] !== undefined) {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusId', null);
      }
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function editSubJobChecklist({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  httpClient
    .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
    .then(({ data }) => {
      console.log(data);
      if (data.result) {
        sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });
        if (data.data['Comments'] === null) {
          data.data['Comments'] = '';
        }

        if (data.data['DateRectified'] !== undefined && data.data['DateRectified'] !== null) {
          data.data['DateRectified'] = moment(data.data['DateRectified'], config.format.date);
        } else {
          data.data['DateRectified'] = null;
        }

        //把处理后的数据赋值给表单
        sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
        sectionComponent.customForm.current?.setState({ formData: data.data });

        setTimeout(() => {
          //设置联动的Select
          getChecklistStatusSelectOptionList({ sectionName: sectionName, parameter: data.data['ChecklistStatusSetId'], formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
        }, config.setTimeoutMilliSecond);
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getChecklistStatusSelectOptionList({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusSetId', parameter);
  httpClient
    .get('Admin/ChecklistStatus/GetSelectOptionList?parameterId=' + parameter)
    .then(({ data }) => {
      if (data.result) {
        let dataSource = data.data;
        let componentDataSource = { ...formComponent.state.componentDataSource };
        dataSource = dataSource.filter(item => item.Value !== 0);
        componentDataSource['ChecklistStatusId'] = dataSource;
        formComponent.setState({ componentDataSource });
        if (dataSource.length > 0) {
          if (dataSource.filter(item => item.Value === sectionComponent.customForm.current?.formRef.current?.getFieldValue('ChecklistStatusId')).length === 0) {
            //搜到的数据源不包括当前值, 说明更换了StatusSet, Status选择新StatusSet里第一个值
            sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusId', dataSource[0].Value);
          }
        } else {
          //搜不到数据源, 移除Status
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusId', null);
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function collapseGroup({ component, key } = {}) {
  let data = component.state.data.map((group, j) => {
    if (group.key === key) {
      if (group.Collapsed !== true) {
        group.Collapsed = true;
      } else {
        group.Collapsed = false;
      }
    }
    return group;
  });
  component.setState({ data });
}


export function getChecklistStatusSets({ sectionComponent, pageComponent } = {}) {
  //写后台
  httpClient
    .get('Admin/ChecklistStatusSet/GetList')
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.child.current?.setState({ checklistStatusSets: data.data });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getSectionDataByChecklistStatusSet({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;

  let searchParameter = {};
  searchParameter.ChecklistStatusId = parameter;
  searchParameter.SubJobId = sectionComponent.props.subJobId;

  sectionComponent.setState({ searchParameter, componentDefaultValue });
  setTimeout(() => {
    // 过滤条件变化后从第一页重新查询，避免当前页超过过滤后的总页数。
    sectionComponent.getSectionDataByDefault(true);
  }, config.setTimeoutMilliSecond);
}

export function manageGroup({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ manageGroupShow: true });
  setTimeout(() => {
    sectionComponent.child.current?.manageGroup.current?.getSubJobChecklistGroupList();
  }, config.setTimeoutMilliSecond);
}

export function quickChangeStatus({ e, sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let subJobChecklistData = sectionComponent.child.current?.state.data.map((group, j) => {
    group.SubJobChecklistList.map((subJobChecklist, k) => {
      if (subJobChecklist.key === parameter.key) {
        subJobChecklist.Loading = true;
      }
      return subJobChecklist;
    })
    return group;
  });
  setTimeout(() => {
    sectionComponent.child.current?.setState({ data: [] });
    sectionComponent.child.current?.setState({ data: subJobChecklistData });

    //写后台
    httpClient
      .put('Business/SubJobChecklist/QuickChangeStatus', { key: parameter.key })
      .then(({ data }) => {
        if (data.result) {
          let subJobChecklistData = sectionComponent.child.current?.state.data.map((group, j) => {
            group.SubJobChecklistList.map((subJobChecklist, k) => {
              if (subJobChecklist.key === parameter.key) {
                subJobChecklist.ChecklistStatusId = data.data.ChecklistStatusId;
                subJobChecklist.ChecklistStatusName = data.data.ChecklistStatusName;
                subJobChecklist.ChecklistStatusBackgroundColor = data.data.ChecklistStatusBackgroundColor;
                subJobChecklist.Loading = false;
              }
              return subJobChecklist;
            })
            return group;
          });
          sectionComponent.child.current?.setState({ data: [] });
          sectionComponent.child.current?.setState({ data: subJobChecklistData });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
  e.stopPropagation();
  return false;
}

export function showStatusMenu({ e, sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ event: e, statusMenuShow: true, checklistStatusSetId: parameter.ChecklistStatusSetId, SubJobChecklistId: parameter.SubJobChecklistId });
  e.preventDefault();
  return false;
}

export function changeStatus({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  //写后台
  httpClient
    .put('Business/SubJobChecklist/ChangeStatus', { key: parameter.key, ChecklistStatusId: parameter.checklistStatusId })
    .then(({ data }) => {
      if (data.result) {
       let subJobChecklistData = sectionComponent.child.current?.state.data.map((group, j) => {
            group.SubJobChecklistList.map((subJobChecklist, k) => {
              if (subJobChecklist.key === parameter.key) {
                subJobChecklist.ChecklistStatusId = data.data.ChecklistStatusId;
                subJobChecklist.ChecklistStatusName = data.data.ChecklistStatusName;
                subJobChecklist.ChecklistStatusBackgroundColor = data.data.ChecklistStatusBackgroundColor;
                subJobChecklist.Loading = false;
              }
              return subJobChecklist;
            })
            return group;
          });
          sectionComponent.child.current?.setState({ data: [] });
          sectionComponent.child.current?.setState({ statusMenuShow: false, data: subJobChecklistData });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ addFromTemplateShow: true });
  setTimeout(() => {
    sectionComponent.child.current?.addFromTemplate.current?.getSubJobTypeDataSource();
  }, config.setTimeoutMilliSecond);
}

export function batchDelete({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    globalFunction.confirm({
      content: 'Do you want to delete these records?',
      okText: 'Delete',
      okType: 'danger',
      callback: function () {
        httpClient
          .post('Business/SubJobChecklist/BatchDelete', sectionComponent.child.current?.state.selectedRowKeys)
          .then(({ data }) => {
            if (data.result) {
              sectionComponent.child.current?.setState({ selectedRowKeys: [] });
              setTimeout(() => {
                sectionComponent.child.current?.getSectionDataByDefault();
              }, config.setTimeoutMilliSecond);
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
          })
          .catch(function (error) {
            globalFunction.handleError(error, pageComponent);
          });
      }
    });
  } else {
    message.warning('You must select at least one checklist item.');
  }
}

export function copySubJobChecklist({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    sectionComponent.child.current?.setState({ copySubJobChecklistShow: true });
    setTimeout(() => {
      sectionComponent.child.current?.copySubJobChecklist.current?.getSubJobDataSource();
    }, config.setTimeoutMilliSecond);
  } else {
    message.warning('You must select at least one checklist item.');
  }
}

//上传Image
export function uploadImage({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.attachImage.current?.setState({
    show: true,
    submitting: false,
    subJobChecklistId: parameter.SubJobChecklistId
  });

  setTimeout(() => {
    console.log(sectionComponent.child.current?.attachImage.current?.state);
  }, 100);
}

//切换SubJobChecklistImage的ShowOnReport
export function changeSubJobChecklistImageShowOnReport({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let that = this;
  httpClient
    .post('Business/SubJobChecklist/ChangeSubJobChecklistImageShowOnReport/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        let newData = sectionComponent.child.current?.state.data.map(group => {
          group.SubJobChecklistList.map(subjobChecklist => {
            if (subjobChecklist.SubJobChecklistImageList !== null) {
              subjobChecklist.SubJobChecklistImageList.map(image => {
                if (image.key === parameter.key) {
                  image.ShowOnReport = !image.ShowOnReport;
                }
                return image;
              });
            }
            return subjobChecklist;
          })
          return group;
        });

        setTimeout(() => {
          sectionComponent.child.current?.setState({ data: [] });
          sectionComponent.child.current?.setState({ data: newData });
        }, config.setTimeoutMilliSecond);
      } else {
        message.error(data.message);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, that.props.pageComponent);
    });
}

//删除SubJobChecklistImage
export function deleteSubJobChecklistImage({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let that = this;
  httpClient
    .delete('Business/SubJobChecklist/DeleteSubJobChecklistImage/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        let newData = sectionComponent.child.current?.state.data.map(group => {
          group.SubJobChecklistList.map(subjobChecklist => {
            if (subjobChecklist.SubJobChecklistImageList !== null) {
              subjobChecklist.SubJobChecklistImageList = subjobChecklist.SubJobChecklistImageList.filter(item => item.key !== parameter.key);
            }
            return subjobChecklist;
          })
          return group;
        });

        setTimeout(() => {
          sectionComponent.child.current?.setState({ data: [] });
          sectionComponent.child.current?.setState({ data: newData });
        }, config.setTimeoutMilliSecond);
      } else {
        message.error(data.message);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, that.props.pageComponent);
    });
}

export function copyToJobChecklist({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.confirm({
    content: 'Copy to job checklist?',
    okText: 'Yes',
    callback: function () {
      httpClient
        .post('Business/SubJobChecklist/CopyToJob', { subJobId: pageComponent.props.subJobId })
        .then(({ data }) => {
          if (data.result) {
            message.success('Copy to job successful');
          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
    }
  });
}

